import { Button, Text } from '@southfields-digital/mxmz-react-ui';

import { DataPreview } from '../DataPreview';

import styles from './DataConnectorPanel.module.scss';

type PreviewSectionProps = {
  graphic: Graphic;
  previewData: PropertyValue;
  onImport: () => void;
  onUpdateProperty: (propertyId: string, value: string | PropertyValue[]) => void;
  isImportDisabled?: boolean;
};

export const PreviewSection = ({
  graphic,
  previewData,
  onImport,
  onUpdateProperty,
  isImportDisabled = false,
}: PreviewSectionProps) => (
  <div className={styles.PreviewSection}>
    <div className={styles.PreviewHeader}>
      <Text as="h3" className={styles.PreviewTitle}>
        Preview Data
      </Text>
      <div className={styles.PreviewActions}>
        <Button onClick={onImport} disabled={isImportDisabled} color="darkGray">
          Import Data
        </Button>
      </div>
    </div>

    <DataPreview graphic={graphic} previewData={previewData} onUpdateProperty={onUpdateProperty} />
  </div>
);
